var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.work && _vm.work.partials && _vm.work.partials.length)?_c('div',{staticClass:"work"},[_c('PartialsLoader',{attrs:{"partials":_vm.work.partials}}),_c('Footer')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }